import React, {Component} from 'react';

import axios from 'axios'
import {locale} from '../locale/AppLocale';
import Loader from '../Components/Loader';
import InfoToolTip from '../Components/InfoToolTip';
import {Link} from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroller';
import {ImageUrl} from '../Helpers/ImageUrl'
import Config from '../Helpers/Config';
import {NotificationManager} from '../Helpers/NotificationManager';;
import {connect} from 'react-redux'
import * as authActions from '../actions/authActions'
import {GetEntityAttribute} from "../Helpers/Entity";


class HideButton extends Component {

    constructor(props){
        super(props);
        this.state = {
            saving:false,
            status:null
        };
        this.save = this.save.bind(this)
    }

    getStatus(){
        if(this.state.status === null){
            return this.props.product.status;
        }
        return this.state.status
    }

    render(){
        if(!this.isUpdatable()){
            return null;
        }
        return (
            <button className="btn-4 btn--small" disabled={this.state.saving} style={{minWidth:90}} onClick={this.save} >
                <Loader completed={this.state.saving === false}/>
                {locale.get(this.getToggleStatus())}
            </button>
        )
    }

    isUpdatable(){
        return Object.keys(this.props.updatableStatuses).filter((status) => {
            return this.getStatus() === this.props.updatableStatuses[status]
        }).length > 0;
    }


    getToggleStatus(){
        return Object.keys(this.props.updatableStatuses).reduce((acc, status) => {
            if(this.getStatus() !== this.props.updatableStatuses[status]){
                acc = status
            }
            return acc;
        },null);
    }

    save(){

        this.setState({
            saving:!this.state.saving
        });

        let status = this.getToggleStatus();

        axios.post(Config.api(`product/update-sell/${this.props.product.id}/status/${status}`), {},{
            withCredentials: Config.withCredentials()
        }).then((response) => {
            this.setState({
                saving: false,
                status:this.props.updatableStatuses[status]
            });
            this.props.onSuccess(this.props.product,response.data.product);
        }).catch((error) => {
            if(error.response.status === 401){
                this.props.requiresReLogin();
            }else{
                if(error.response.data && error.response.data.message){
                    NotificationManager.error(error.response.data.message);
                }else{
                    NotificationManager.error(error.message);
                }
            }
            this.setState({saving: false});
        });

    }
}


class ProductRow extends Component {

    constructor(props){

        super(props);

        this.state = {
            status_text:null,
            status:null
        };
    }

    getStatusText(){
        if(this.state.status_text === null){
            return GetEntityAttribute(this.props.product,'status_text');
            // return this.props.product.status_text;
        }
        return this.state.status_text
    }

    getAdminNotes(){
        if(!this.props.product.admin_notes){
            return  null
        }
        return <InfoToolTip text={this.props.product.admin_notes} />
    }

    getStatus(){
        if(this.state.status === null){
            return this.props.product.status;
        }
        return this.state.status
    }

    render(){
        const {params,product} = this.props
        return (
            <tr >
                <td width={'100px'}>
                    <Link
                        to={`/${params.businessSlug}/update-sell/${encodeURIComponent(product.id)}`}><img
                        src={ImageUrl(product.image, 100, 100, 'c2')} width={100} alt=""/></Link>

                </td>
                <td>
                    <Link
                        to={`/${params.businessSlug}/update-sell/${encodeURIComponent(product.id)}`}>{GetEntityAttribute(product,'title')}</Link>

                </td>
                <td>
                    <div className={`badge badge--${this.getStatus()}` }>
                        {this.getStatusText()}
                    </div>
                    {this.getAdminNotes()}
                </td>
                <td>{product.price}</td>
                <td>{product.old_price}</td>
                <td>{product.quantity}</td>
                <td>{product.updated_at}</td>
                <td>{product.views?product.views:0}</td>
                <td>
                    <Link
                        className="btn-1 btn--small"
                        to={`/${params.businessSlug}/update-sell/${encodeURIComponent(product.id)}`}>{locale.get('update_sell_product')}</Link>
                </td>

                <td>
                    <Link
                        className="btn-2 btn--small"
                        to={`/${params.businessSlug}/update/${encodeURIComponent(product.id)}`}>{locale.get('update_product_props')}</Link>

                </td>

                <td style={{width:1}}>
                    <HideButton
                        onSuccess={(product,productResponse) => {
                            this.setState({
                                status_text:productResponse.status_text,
                                status:productResponse.status,
                            });
                        }}
                        updatableStatuses={this.props.updatableStatuses}
                        requiresReLogin={this.props.requiresReLogin}
                        product={product}/>
                </td>
            </tr>
        )
    }
}


class ManageProducts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            products: [],
            tabStatuses: [],
            keyword: props.match.params.keyword || '',
            has_more: true,
            is_loading: false,
            fetched: false,
            status: props.match.params.status || 'all',
            updatableStatuses:{},
            pagination: {
                page: 1,
                pages: 1,
                total: 0,
                count: 0
            }
        };
        this.fetchProducts = this.fetchProducts.bind(this);
        this.renderTable = this.renderTable.bind(this);
        this.renderTabs = this.renderTabs.bind(this);
        this.loadMore = this.loadMore.bind(this);
        this.updateProductList = this.updateProductList.bind(this);
        this.fetchByStatus = this.fetchByStatus.bind(this);
        this.changeKeyword = this.changeKeyword.bind(this);
        this.submitSearch = this.submitSearch.bind(this);
    }

    componentDidMount() {
        if(!this.props.auth.can_request){
            return false;
        }

        this.fetchProducts(this.getCurrentStatus());
    }

    fetchByStatus(e, statusId) {
        e.preventDefault();

        if (statusId === this.getCurrentStatus()) {
            return;
        }
        this.props.history.push(`/${this.props.match.params.businessSlug}/manage/${statusId}`);
        this.setState({status: statusId, fetched: false, products: []});
        this.fetchProducts(statusId);
    }

    fetchProducts(statusId, scrollId = null, keyword = null) {
        let url = `${Config.api()}products/listing-sells/${this.props.auth.business.id}?status=${statusId}`;

        if (!keyword) {
            keyword = this.state.keyword;
        }

        if (keyword && keyword.length) {
            url = url + '&keyword=' + keyword;
        }

        if (scrollId) {
            url = url + '&page=' + scrollId;
        }

        axios.get(url, {
            withCredentials: Config.withCredentials()
        })
            .then((response) => {
                if (response.status === 200) {
                    this.setState({
                        fetched: true,
                        pagination: response.data.pagination,
                        tabStatuses: response.data.statuses,
                        updatableStatuses:response.data.updatable_statuses
                    });
                    this.updateProductList(response.data);
                }
            }).catch((error) => {
                if(error.response.status === 401){
                    this.props.requiresReLogin();
                }else{
                    NotificationManager.error(error.message);
                }
                this.setState({fetched: false});
        });
    }

    updateProductList(response) {
        let products = this.state.products;
        let canLoadMore = false;
        response.results.forEach((product) => {
            products.push(product);
        });
        if (response.pagination.count > 0) {
            canLoadMore = true;
        }
        this.setState({products: products, has_more: canLoadMore, is_loading: false});
    }

    loadMore(event) {
        if (!this.state.pagination.page === this.state.pagination.pages || this.state.is_loading) {
            return;
        }
        this.setState({is_loading: true});
        let scrollId = this.state.pagination.page + 1;
        this.fetchProducts(this.getCurrentStatus(), scrollId);
    }

    getCurrentStatus() {
        if (this.state.status === 'all' || isNaN(this.state.status)) {
            return 'all';
        }
        return parseInt(this.state.status, 10);
    }

    changeKeyword(e) {
        this.setState({keyword: e.target.value});
    }

    submitSearch(e) {
        e.preventDefault();
        if (this.state.keyword.length < 3) {
            NotificationManager.error(locale.get('minimum_characters_to_search'));
            return false;
        }

        this.setState({fetched: false, products: []});
        this.props.history.push(`/${this.props.match.params.businessSlug}/manage/${this.getCurrentStatus()}/${this.state.keyword}`);
        this.fetchProducts(this.getCurrentStatus(), null, this.state.keyword);
    }

    renderTabs() {
        return (
            <div className="panel-1--tabs">
                <ul>
                    {this.state.tabStatuses.map((status, index) => {
                        return (
                            <li key={index}
                                className={ this.getCurrentStatus() === status.id ? 'active' : '' }>
                                <Link to={`/${this.props.match.params.businessSlug}/manage/${status.id}`}
                                      onClick={(e) => {
                                          e.preventDefault();
                                          this.fetchByStatus(e, status.id);
                                      }}>{GetEntityAttribute(status,'title')}</Link>
                            </li>
                        )
                    })}
                </ul>
            </div>
        )
    }

    renderTable() {
        return (
            <div>
                <table className="table no-border-top">
                    <thead>
                    <tr>
                        <th colSpan="2">{locale.get('product_name')}</th>
                        <th>{locale.get('status')}</th>
                        <th>{locale.get('price')}</th>
                        <th>{locale.get('old_price')}</th>
                        <th>{locale.get('quantity')}</th>
                        <th>{locale.get('updated_at')}</th>
                        <th>{locale.get('views')}</th>
                        <th colSpan="3"></th>
                    </tr>
                    </thead>
                    <tbody>

                    {this.state.products.map((product, index) => (
                        <ProductRow
                            params={this.props.match.params}
                            product={product}
                            updatableStatuses={this.state.updatableStatuses}
                            requiresReLogin={this.props.requiresReLogin}
                            key={product.id} />
                    ))}
                    </tbody>
                </table>

            </div>
        );
    }

    render() {
        return (
            <div className="panel-1">
                <div className="panel-1--head no-border-btm">
                    {locale.get('manage_products_offers')}

                    <form className="panel-1--head--form" onSubmit={this.submitSearch}>
                        <input type="text" className="input-search-form" name="keyword" value={this.state.keyword || ''}
                               placeholder={ locale.get('search_placeholder')} onChange={this.changeKeyword}/>
                        <button className="btn-1">

                            <svg version="1.1" x="0px" y="0px" viewBox="0 0 56.966 56.966"
                                 style={ {enableBackground: 'new 0 0 56.966 56.966'} } xmlSpace="preserve">
                                <path
                                    d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23 s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92 c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17 s-17-7.626-17-17S14.61,6,23.984,6z"
                                    fill="#FFFFFF"/>
                                <g></g>
                                <g></g>
                                <g></g>
                                <g></g>
                                <g></g>
                                <g></g>
                                <g></g>
                                <g></g>
                                <g></g>
                                <g></g>
                                <g></g>
                                <g></g>
                                <g></g>
                                <g></g>
                                <g></g>
                            </svg>

                        </button>
                    </form>

                </div>
                {this.renderTabs()}
                <Loader completed={this.state.fetched}>
                    <InfiniteScroll
                        pageStart={0}
                        initialLoad={false}
                        loadMore={this.loadMore}
                        hasMore={this.state.pagination.page < this.state.pagination.pages}
                        loader={<div><Loader completed={this.state.is_loading === false}/></div>}
                    >

                        {this.renderTable()}
                    </InfiniteScroll>

                </Loader>

                {this.state.has_more === false ? (
                        <div className="panel-1--footer text-center">{locale.get('no_more_products_or_offers')}</div>
                    ) : (
                        <span></span>
                    )}
            </div>
        );
    }
}

// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {
        auth: state.auth
    }
};


// Maps actions to props
const mapDispatchToProps = (dispatch) => ({
    requiresReLogin: ()=>dispatch(authActions.requiresRelogin(true,true))
});
export default connect(mapStateToProps, mapDispatchToProps)(ManageProducts);
